<template>
    <Body>
        <div class="wrapper-list">
            <TierItem
                v-for="(item, idx) of tierList"
                :key="`tier-${idx}`"
                :item="item"
                @onClickTier="onClickTier"
            ></TierItem>
        </div>
    </Body>
</template>
<script>
//component
// import Util from "@/helper/Utility.js";
import TierItem from "../Tier/TierItem.vue";
import Body from "../Body/Body.vue";
export default {
    name: "Tier",
    props: {
        lbl: Object,
        lblCode: Number,
        theme: String,
        blobConfig: Object,
        objTier: Object,
        points: Number,
    },
    emits: ["onClickTier"],
    components: {
        TierItem,
        Body,
    },
    data: function () {
        return {
            tierList: [],
            appName: "",
            currentPoints: 0,
        };
    },
    created: function () {
        if (this.objTier.point) {
            this.tierList = this.objTier.point;
        } else {
            this.tierList = [];
        }
    },
    mounted: function () {},
    methods: {
        onClickTier: function (data) {
            this.$emit("onClickTier", data);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/Bitkub/style/base.scss";
@import "style/Tier.scss";
</style>

